import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { listFieldglassShiftIssues } from 'api/admin/fieldglass/listFieldglassShiftIssues'
import { fieldglassKeys } from './keys'

export const useFieldglassShiftIssuesQuery = (
  request: Parameters<typeof listFieldglassShiftIssues>[0]
) => {
  return useQuery({
    queryKey: fieldglassKeys.shiftIssuesList(request),
    queryFn: () => listFieldglassShiftIssues(request),
    placeholderData: keepPreviousData,
  })
}
